import KiPortalBaseEntity from 'portal-base/src/base/ki-portal-base-entity';

class KiDsPwaComponent extends KiPortalBaseEntity {}

export { KiDsPwaComponent };
